import { render, staticRenderFns } from "./questionsDel.vue?vue&type=template&id=9caa773a&"
import script from "./questionsDel.vue?vue&type=script&lang=js&"
export * from "./questionsDel.vue?vue&type=script&lang=js&"
import style0 from "./questionsDel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports